"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formUrl = exports.getAccountDashboardUrl = exports.addonCustomSsl = exports.bundle = exports.suite = exports.partnerProgramPaywall = exports.productsAndAddons = exports.technicalConsultingBlock = exports.inboundConsultingBlock = exports.serviceProfessionalOnboarding = exports.salesProfessionalOnboarding = exports.serviceStarterKit = exports.serviceInPersonTraining = exports.serviceDesignatedTechnicalSupport = exports.getPaidUserManagementUrl = exports.checkout = exports.addonTransactionalEmail = exports.addonAdditionalPortalLink = exports.addonDedicatedIp = exports.addonBrandDomain = exports.addonCrm = exports.cmsPricing = exports.addonWebsite = exports.addonAds = exports.addonReporting = exports.starterContacts = exports.servicePricing = exports.marketingPricing = exports.salesPricing = exports.mapRedirectTargetToRoute = void 0;

var _enviro = _interopRequireDefault(require("self-service-api/core/utilities/enviro"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _params = require("hub-http/helpers/params");

var _url = require("hub-http/helpers/url");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var _MerchandiseIds = require("../../constants/MerchandiseIds");

var pid = _PortalIdParser.default.get();

var suffix = _enviro.default.isProd() ? '' : 'qa';

var baseUrlOptions = function baseUrlOptions() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';
  return {
    protocol: 'https',
    hostname: env + ".hubspot" + suffix + ".com"
  };
};

var formUrlOptions = {
  protocol: 'https',
  hostname: "api.hsforms" + suffix + ".com"
};

var _createExternalUrl = function _createExternalUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isLocal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var urlOptions = Object.assign({}, baseUrlOptions(isLocal ? 'local' : 'app'), {
    path: path,
    query: (0, _params.stringify)(query)
  });
  return (0, _url.buildUrl)(urlOptions);
};

var _createProductsAndAddonsLink = function _createProductsAndAddonsLink() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;

  if (params && !params.upgradeSource) {
    _devLogger.default.warn({
      message: "createProductsAndAddonsLink: Expected upgradeSource for path " + path + " but got " + params.upgradeSource,
      key: "createProductsAndAddonsLink: " + path
    });
  }

  var urlOptions = Object.assign({}, baseUrlOptions(), {
    path: "/browse/" + pid + "/" + path,
    query: (0, _params.stringify)(params)
  });
  return (0, _url.buildUrl)(urlOptions);
};

var _createPricingPageLink = function _createPricingPageLink() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var params = arguments.length > 1 ? arguments[1] : undefined;

  if (params && !params.upgradeSource) {
    _devLogger.default.warn({
      message: "createPricingPageLink: Expected upgradeSource for path " + path + " but got " + params.upgradeSource,
      key: "createPricingPageLink: " + path
    });
  }

  var urlOptions = Object.assign({}, baseUrlOptions(), {
    path: "/pricing/" + pid + "/" + path,
    query: (0, _params.stringify)(params)
  });
  return (0, _url.buildUrl)(urlOptions);
};

var redirectRoutes = {
  'landing-pages': "/pages/" + pid + "/manage/landing",
  email: "/email/" + pid + "/manage",
  'marketing-workflows': "/workflows/" + pid,
  'content-strategy': "/content-strategy/" + pid + "/clusters",
  'sales-workflows': "/workflows/" + pid,
  playbooks: "/playbooks/" + pid,
  sequences: "/sequences/" + pid,
  quotes: "/settings/" + pid + "/sales/products",
  tickets: "/contacts/" + pid + "/tickets/list/view/all",
  feedback: "/feedback/" + pid + "/home",
  'knowledge-base': "/knowledge/" + pid + "/insights/dashboard",
  'service-workflows': "/workflows/" + pid,
  meetings: "/meetings/" + pid,
  'user-settings': "/settings/" + pid + "/users?createUserEmail"
};

var mapRedirectTargetToRoute = function mapRedirectTargetToRoute(redirectTarget, upgradeProduct) {
  if (redirectRoutes[redirectTarget]) {
    return redirectRoutes[redirectTarget];
  }

  var hub = upgradeProduct.split('-')[0];
  return upgradeProduct === _UpgradeProducts.SALES_PROFESSIONAL ? "/getting-started/" + pid : "/reports-dashboard/" + pid + "/" + hub;
};

exports.mapRedirectTargetToRoute = mapRedirectTargetToRoute;

var salesPricing = function salesPricing(upgradeSource) {
  return _createPricingPageLink('sales', {
    upgradeSource: upgradeSource
  });
};

exports.salesPricing = salesPricing;

var marketingPricing = function marketingPricing(upgradeSource) {
  return _createPricingPageLink('marketing', {
    upgradeSource: upgradeSource
  });
};

exports.marketingPricing = marketingPricing;

var servicePricing = function servicePricing(upgradeSource) {
  return _createPricingPageLink('service', {
    upgradeSource: upgradeSource
  });
};

exports.servicePricing = servicePricing;

var starterContacts = function starterContacts() {
  var urlOptions = Object.assign({}, baseUrlOptions(), {
    path: "/pricing/" + pid + "/confirm-contacts?marketing-starter"
  });
  return (0, _url.buildUrl)(urlOptions);
};

exports.starterContacts = starterContacts;

var addonReporting = function addonReporting(upgradeSource) {
  return _createProductsAndAddonsLink('upgrade/reporting', {
    upgradeSource: upgradeSource
  });
};

exports.addonReporting = addonReporting;

var addonAds = function addonAds(upgradeSource) {
  return _createProductsAndAddonsLink('upgrade/ads', {
    upgradeSource: upgradeSource
  });
};

exports.addonAds = addonAds;

var addonWebsite = function addonWebsite(upgradeSource) {
  return _createProductsAndAddonsLink('compare/website', {
    upgradeSource: upgradeSource
  });
};

exports.addonWebsite = addonWebsite;

var cmsPricing = function cmsPricing(upgradeSource) {
  return _createPricingPageLink('cms', {
    upgradeSource: upgradeSource
  });
};

exports.cmsPricing = cmsPricing;

var addonCrm = function addonCrm(upgradeSource) {
  return _createPricingPageLink('crm', {
    upgradeSource: upgradeSource
  });
};

exports.addonCrm = addonCrm;

var addonBrandDomain = function addonBrandDomain(upgradeSource) {
  return _createProductsAndAddonsLink('upgrade/brand-domain', {
    upgradeSource: upgradeSource
  });
};

exports.addonBrandDomain = addonBrandDomain;

var addonDedicatedIp = function addonDedicatedIp(upgradeSource) {
  return _createProductsAndAddonsLink('services/dedicated-ip', {
    upgradeSource: upgradeSource
  });
};

exports.addonDedicatedIp = addonDedicatedIp;

var addonAdditionalPortalLink = function addonAdditionalPortalLink(upgradeSource) {
  return _createProductsAndAddonsLink('services/add-on-portal', {
    upgradeSource: upgradeSource
  });
};

exports.addonAdditionalPortalLink = addonAdditionalPortalLink;

var addonTransactionalEmail = function addonTransactionalEmail(upgradeSource) {
  return _createProductsAndAddonsLink('services/transactional-email', {
    upgradeSource: upgradeSource
  });
};

exports.addonTransactionalEmail = addonTransactionalEmail;

var checkout = function checkout(orderId, upgradeSource) {
  return _createExternalUrl("/checkout/" + pid + "/purchases/" + orderId + (upgradeSource ? "?upgradeSource=" + upgradeSource : ''));
};

exports.checkout = checkout;

var getPaidUserManagementUrl = function getPaidUserManagementUrl() {
  return _createExternalUrl("/settings/" + pid + "/users/paid-users");
};

exports.getPaidUserManagementUrl = getPaidUserManagementUrl;

var serviceDesignatedTechnicalSupport = function serviceDesignatedTechnicalSupport(upgradeSource) {
  return "https://www.hubspot.com/services/consulting/technical?source=" + upgradeSource;
};

exports.serviceDesignatedTechnicalSupport = serviceDesignatedTechnicalSupport;

var serviceInPersonTraining = function serviceInPersonTraining(upgradeSource) {
  return "https://www.hubspot.com/services/classroom-training?source=" + upgradeSource;
};

exports.serviceInPersonTraining = serviceInPersonTraining;

var serviceStarterKit = function serviceStarterKit(upgradeSource) {
  return _createProductsAndAddonsLink('services/starter-kit', {
    upgradeSource: upgradeSource
  });
};

exports.serviceStarterKit = serviceStarterKit;

var salesProfessionalOnboarding = function salesProfessionalOnboarding(upgradeSource) {
  return _createProductsAndAddonsLink('services/sales-professional-onboarding', {
    upgradeSource: upgradeSource
  });
};

exports.salesProfessionalOnboarding = salesProfessionalOnboarding;

var serviceProfessionalOnboarding = function serviceProfessionalOnboarding(upgradeSource) {
  return _createProductsAndAddonsLink('services/service-professional-onboarding', {
    upgradeSource: upgradeSource
  });
};

exports.serviceProfessionalOnboarding = serviceProfessionalOnboarding;

var inboundConsultingBlock = function inboundConsultingBlock(upgradeSource) {
  return _createProductsAndAddonsLink('services/inbound-consulting-block', {
    upgradeSource: upgradeSource
  });
};

exports.inboundConsultingBlock = inboundConsultingBlock;

var technicalConsultingBlock = function technicalConsultingBlock(upgradeSource) {
  return _createProductsAndAddonsLink('services/technical-consulting-block', {
    upgradeSource: upgradeSource
  });
};

exports.technicalConsultingBlock = technicalConsultingBlock;

var productsAndAddons = function productsAndAddons() {
  return _createPricingPageLink();
}; // This paywall is where you'd go to upgrade to Partner status


exports.productsAndAddons = productsAndAddons;

var partnerProgramPaywall = function partnerProgramPaywall() {
  var urlOptions = Object.assign({}, baseUrlOptions(), {
    path: "/upgrade/" + pid + "/partner-program"
  });
  return (0, _url.buildUrl)(urlOptions);
};

exports.partnerProgramPaywall = partnerProgramPaywall;

var suite = function suite(upgradeSource) {
  return _createPricingPageLink('products/growth-suite', {
    upgradeSource: upgradeSource
  });
};

exports.suite = suite;

var bundle = function bundle(upgradeSource) {
  return _createPricingPageLink('bundle', {
    upgradeSource: upgradeSource
  });
};

exports.bundle = bundle;

var addonCustomSsl = function addonCustomSsl(upgradeSource) {
  return _createPricingPageLink('bundle', {
    upgradeSource: upgradeSource,
    selectedAddOns: _MerchandiseIds.ADDON_CUSTOM_SSL
  });
};

exports.addonCustomSsl = addonCustomSsl;

var getAccountDashboardUrl = function getAccountDashboardUrl() {
  return _createExternalUrl("/account-and-billing/" + _PortalIdParser.default.get());
};

exports.getAccountDashboardUrl = getAccountDashboardUrl;

var formUrl = function formUrl(_ref) {
  var portalId = _ref.portalId,
      formId = _ref.formId;
  var urlOptions = Object.assign({}, formUrlOptions, {
    path: "/submissions/v3/integration/submit/" + portalId + "/" + formId
  });
  return (0, _url.buildUrl)(urlOptions);
};

exports.formUrl = formUrl;